/** Plot tree mapping applies to REDD+ (forestry), ARR, and Grassland — DB values unchanged for forestry. */
export const PLOT_TREE_MAPPING_PROJECT_TYPES = ['forestry', 'arr', 'grassland'];

export function isPlotTreeMappingApplicable(projectType) {
  return PLOT_TREE_MAPPING_PROJECT_TYPES.includes(projectType);
}

/** i18n keys under carbonCredit.* */
export const PROJECT_TYPE_I18N_KEYS = {
  forestry: 'reddPlus',
  avoided_deforestation: 'reddPlus',
  arr: 'arr',
  biochar: 'biochar',
  erw: 'erw',
  grassland: 'grassland',
  regenerative_agriculture: 'regenerative_agriculture',
  agroforestry: 'agroforestry',
};

export function getProjectTypeLabel(vm, value) {
  if (!value) return '—';
  const key = PROJECT_TYPE_I18N_KEYS[value];
  return key ? vm.$t(`carbonCredit.${key}`) : value;
}
